import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../../../system/components/icon";
import {projectMeetingsApi} from "../../../models/project/project-meetings-api";
import "./task-decision-tag.css";

// «تصمیم: …» on a task in the task lists and boards: which meeting decision the task carries out (boss's feedback
// 2026-10-25; docs/tasks/27-meetings-feedback.md). One request for the whole workspace, shared by every card, read
// again after a minute or when the meetings tab changes something.

export const DECISIONS_CHANGED = "meeting-decisions:changed";
const FRESH_MS = 60000;
const store = {map: new Map(), loadedAt: 0, loading: null, listeners: new Set()};

function publish() {
    store.listeners.forEach((listener) => listener(store.map));
}

export async function loadTaskDecisions(force = false) {
    if (store.loading) return store.loading;
    if (!force && Date.now() - store.loadedAt < FRESH_MS) return store.map;
    store.loading = projectMeetingsApi.taskDecisions()
        .then((rows) => {
            store.map = new Map((rows || []).map((row) => [row.task, row.decisions || []]));
            store.loadedAt = Date.now();
            publish();
            return store.map;
        })
        .catch(() => store.map)
        .finally(() => { store.loading = null; });
    return store.loading;
}

export function useTaskDecisions() {
    const [map, setMap] = useState(store.map);
    useEffect(() => {
        store.listeners.add(setMap);
        loadTaskDecisions();
        const refresh = () => loadTaskDecisions(true);
        window.addEventListener(DECISIONS_CHANGED, refresh);
        return () => {
            store.listeners.delete(setMap);
            window.removeEventListener(DECISIONS_CHANGED, refresh);
        };
    }, []);
    return map;
}

export function decisionsOfTask(map, task) {
    return map.get(String(task?.documentId || "")) || [];
}

export default function TaskDecisionTag({task, className = ""}) {
    const map = useTaskDecisions();
    const navigate = useNavigate();
    const decisions = decisionsOfTask(map, task);
    if (!decisions.length) return null;
    const first = decisions[0];
    const title = decisions.map((item) => item.title).join("، ");
    return (
        <button type="button" className={`task-decision-tag ${className}`} title={`تصمیم: ${title}`} aria-label={`تصمیم: ${title}`}
                onPointerDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                    event.stopPropagation();
                    if (first.project) navigate(`/projects/${first.project}?tab=meetings`);
                }}>
            <Icon icon="mi mi:gavel" className="text-xs"/>
            <span className="task-decision-tag-text">{`تصمیم: ${first.title}`}</span>
            {decisions.length > 1 && <span>{`+${(decisions.length - 1).toLocaleString("fa-IR")}`}</span>}
        </button>
    );
}
